module.exports = __webpack_public_path__ + "img/yuanwai.1a050f87.png";